import { Pipe, type PipeTransform } from '@angular/core';

@Pipe({
  name: 'pctFormResolveErrorKey',
})
export class ResolveErrorKeyPipe implements PipeTransform {
  transform(
    errorKey: string,
    scope: string,
    overrideErrors: Record<string, string> | undefined,
  ): string {
    if (overrideErrors !== undefined && errorKey in overrideErrors) {
      return overrideErrors[errorKey];
    }
    return `${scope}.${errorKey}`;
  }
}
